import type { StartPayConfig } from "../types/config";
import type { VerifyPaymentInput } from "../types/payment";
import type { StartPayResponse } from "../types/response";
import { buildUrl } from "../utils/buildUrl";
import { requestJson } from "../utils/request";
import { DEFAULT_ENDPOINTS } from "./constants";

export const verifyPayment = (config: StartPayConfig, input: VerifyPaymentInput) => {
  const endpoint = config.endpoints?.verifyPayment ?? DEFAULT_ENDPOINTS.verifyPayment;

  // Final verification belongs on the backend so secret keys never enter the browser.
  return requestJson<StartPayResponse>(buildUrl(config.apiBaseUrl, endpoint), {
    body: input,
    headers: config.headers,
    timeout: config.timeout,
    signal: input.signal
  });
};
